module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/0328d276f1e06552dfb95bfc07b1459e.svg";